<div class="wrapper__contentComponent--expediente container my-5">
  <!-- Main panel -->
  <ng-container *ngIf="listFlag">
    <div
      class="d-flex justify-content-between align-items-center mb-3"
      *ngIf="!subDominioFlag">
      <h2>Lista de dominios base</h2>
      <button
        id="crearDominio"
        class="btn-govco fill-btn-govco hvr-shrink ms-2"
        (click)="crearDominio()">
        <span class="govco-svg govco-plus-circle me-2"></span>
        Crear dominio
      </button>
    </div>
    <div
      class="d-flex justify-content-between align-items-center mb-3"
      *ngIf="subDominioFlag">
      <h2>Subdominios</h2>
      <button
        id="volverDominio"
        class="btn-govco btn-govco hvr-shrink ms-2"
        (click)="volverPadre()">
        <span class="govco-svg govco-arrow-circle-left me-2"></span>
        Volver a nivel superior
      </button>
      <button
        id="crearDominio"
        class="btn-govco fill-btn-govco hvr-shrink ms-2"
        (click)="crearDominio()">
        <span class="govco-svg govco-plus-circle me-2"></span>
        Crear subdominio
      </button>
    </div>
    <div class="d-flex justify-content-between mb-3">
      <p class="justify-text">
        En el contexto de inteligencia artificial (IA) y bases de conocimiento,
        el término dominio se refiere al área específica de conocimiento sobre
        la cual un sistema de IA o una base de conocimiento está diseñado para
        operar. Un dominio define el alcance y los límites de la información que
        el sistema puede manejar, procesar y razonar.
      </p>
    </div>
    <div class="d-flex justify-content-end mb-3">
      <div class="input-group w-50">
        <input
          type="text"
          class="form-control"
          placeholder="Buscar por nombre"
          [(ngModel)]="searchTerm" />
        <span class="input-group-text">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-search"
            viewBox="0 0 16 16">
            <path
              d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.415l-3.85-3.85a1.007 1.007 0 0 0-.115-.098zm-5.442 1.398a5.5 5.5 0 1 1 0-11 5.5 5.5 0 0 1 0 11z" />
          </svg>
        </span>
      </div>
    </div>
    <!-- Tabla de dominios -->
    <div class="table-container" *ngIf="dominios.length > 0; else noData">
      <table class="table table-striped table-bordered">
        <thead class="custom-header">
          <tr>
            <th>Nombre</th>
            <th class="display-none">Estado</th>
            <th class="display-none">Fecha Modificación</th>
            <th class="display-none">Usuario</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="
              let dominio of dominios
                | filter: searchTerm : 'Nombre'
                | paginate: { itemsPerPage: 5, currentPage: currentPage }
            "
            class="hover-effect">
            <td>{{ dominio.Nombre }}</td>
            <td class="display-none">{{ dominio.Estado }}</td>
            <td class="display-none">
              {{ dominio.FechaModificacion | date: 'yyyy-MM-dd HH:mm' }}
            </td>
            <td class="display-none">{{ dominio.UsuarioModificacion }}</td>
            <td class="btns-box">
              <button
                class="btn btn-sm btn-outline-primary"
                (click)="onRowClick(dominio)">
                Ver
              </button>
              <button
                class="btn btn-sm btn-outline-primary"
                (click)="editarDominio(dominio)">
                Editar
              </button>
              <button
                class="btn btn-sm btn-outline-primary"
                (click)="eliminarDominio(dominio.Id)">
                Eliminar
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- Pagination Controls -->
      <pagination-controls
        (pageChange)="currentPage = $event"
        previousLabel="Anterior"
        nextLabel="Siguiente"
        class="d-flex justify-content-center mt-3">
      </pagination-controls>
    </div>
    <!-- Plantilla para mostrar mensaje si no hay datos -->
    <ng-template #noData>
      <div class="no-data-container">
        <p>{{ mensaje }}</p>
      </div>
    </ng-template>
  </ng-container>
  <!-- Read panel -->
  <ng-container *ngIf="readFlag">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h2>Formulario de Dominio</h2>
      <button
        id="detalleDominio"
        class="btn-govco fill-btn-govco hvr-shrink ms-2"
        (click)="volverElemento()">
        <span class="govco-svg govco-arrow-circle-left me-2"></span>
        Volver a la lista
      </button>
    </div>
    <form [formGroup]="dominioForm" (ngSubmit)="submitForm()">
      <div class="row">
        <div *ngFor="let field of nomDesForm" class="col-md-{{ field.width }}">
          <div *ngIf="field.visible" class="mb-3">
            <label [for]="field.name" class="form-label"
              >{{ field.label
              }}<span
                *ngIf="field.required"
                _ngcontent-ng-c3465959523=""
                class="text-danger">
                *</span
              ></label>
            <!-- Text Input -->
            <input
              *ngIf="field.type === 'text'"
              [id]="field.name"
              [type]="field.type"
              class="form-control"
              [formControlName]="field.name"
              [readonly]="isReadOnly" />
            <!-- Textarea -->
            <textarea
              *ngIf="field.type === 'textarea'"
              [id]="field.name"
              class="form-control"
              [formControlName]="field.name"
              rows="3"
              [readonly]="isReadOnly"></textarea>
            <!-- Select Dropdown -->
            <select
              *ngIf="field.type === 'select' && field.visible"
              [id]="field.name"
              class="form-select"
              [formControlName]="field.name"
              [disabled]="isReadOnly">
              <option *ngFor="let option of estados" [value]="option">
                {{ option }}
              </option>
            </select>

            <div
              class="form-check form-switch"
              *ngIf="field.type === 'checkbox'">
              <input
                class="form-check-input"
                type="checkbox"
                id="indexado"
                formControlName="indexado" />
            </div>

            <!-- Validation Error Messages -->
            <div *ngIf="getErrorMessage(field.name)" class="text-danger">
              {{ getErrorMessage(field.name) }}
            </div>
          </div>
        </div>
      </div>
      <div class="mt-3 d-flex gap-2">
        <button
          type="button"
          class="btn-govco fill-btn-govco"
          (click)="toggleEdit()"
          *ngIf="isReadOnly">
          Editar
        </button>
        <button
          type="submit"
          class="btn-govco fill-btn-govco"
          *ngIf="!isReadOnly">
          Guardar
        </button>
        <button
          type="button"
          class="btn-govco btn-govco"
          (click)="toggleEdit()"
          *ngIf="!isReadOnly">
          Cancelar
        </button>
      </div>
    </form>
    <!-- Conjunto de datos -->
    <div class="d-flex justify-content-between align-items-center mb-3 mt-5">
      <h4 class="title-section">Conjunto de datos</h4>
    </div>
    <div *ngIf="dominio.DataSet; else noDataC">
      <div class="no-data-container">
        <p style="color: green">
          Identificador del conjunto de datos {{ dominio.DataSet }}
        </p>
      </div>
    </div>
    <!-- Plantilla para mostrar mensaje si no hay datos -->
    <ng-template #noDataC>
      <div class="no-data-container">
        <p>Conjunto de datos vacio.</p>
      </div>
    </ng-template>
    <!-- Carga de nuevo archivo -->
    <div
      class="upload-container mt-5"
      [class.dragging]="isDragging"
      (dragover)="onDragOver($event)"
      (dragleave)="onDragLeave($event)"
      (drop)="onDrop($event)">
      <h5>Cargar nuevo archivo</h5>
      <div class="upload-box">
        <label for="fileUpload">
          <span class="upload-icon">⬆</span>
          <br />
          Arrastre el archivo .TXT o .PDF (máximo 10MB) aquí o haga clic para seleccionar un archivo
        </label>
        <input
          id="fileUpload"
          type="file"
          class="file-input"
          accept=".txt, application/pdf"
          (change)="onFileSelected($event)" />
      </div>
    </div>
    <!-- Formulario edición contenido de dataset -->
    <div *ngIf="dominio.DataSet && !isBinaryFlag" class="mb-5 mt-5">
      <h5 class="text-center">Edita el contenido del dataset</h5>
      <div class="w-100 mt-3 mb-5">
        <form [formGroup]="datasetform">
          <quill-editor
            class="form-control mb-3"
            formControlName="Contenido"
            [modules]="quillConfig"
            placeholder="Ingresa el texto aquí...">
          </quill-editor>
          <div class="d-flex justify-content-start gap-2">
            <button
              (click)="this.editarContenidoDataset()"
              type="submit"
              [disabled]="!this.editableDatasetFlag"
              class="btn-govco fill-btn-govco">
              Guardar
            </button>
            <button
              (click)="this.eliminarDataset()"
              type="button"
              class="btn-govco bg-danger text-white">
              Eliminar
            </button>
          </div>
        </form>
      </div>
    </div>
    <!-- Carga de assets imagen de pdf: src/assets/icons/file-pdf.svg -->
    <div *ngIf="isBinaryFlag" class="mb-5 mt-5">
      <h5 class="text-center">Archivo PDF</h5>
      <img
        class="img-file-pdf"
        src="assets/icons/file-pdf.svg"
        alt="Archivo PDF" 
      /> 
    </div>
    <!-- Carga de url video -->
    <div class="mt-5">
      <h5 class="text-center">Cargar un video</h5>
      <div class="d-flex align-items-end justify-content-between p-2">
        <form
          [formGroup]="videoForm"
          class="d-flex flex-grow-1 align-items-end"
          (ngSubmit)="submitVideoForm()">
          <div class="flex-grow-1 me-2">
            <label for="videoUrl" class="form-label">Url Video (máximo 50MB)</label>
            <input
              formControlName="videoUrl"
              id="videoUrl"
              class="form-control" />
          </div>
          <button type="submit" class="btn-govco fill-btn-govco">
            Procesar Video
          </button>
        </form>
      </div>
    </div>    
  </ng-container>
</div>
<div *ngIf="modalNDFlag">
  <app-modal-nom-des
    [elements]="dominios"
    (ndEmitter)="registrarDominio($event)">
  </app-modal-nom-des>
</div>
